<div class="container">
  <div class="row d-flex justify-content-center py-5">
    <div class="col-sm-10 col-md-6 col-lg-4 p-5 card">

      <!-- LOGO -->
      <div class="row d-flex justify-content-center mb-4">
        <div class="d-flex justify-content-center col-12"><img alt="Mailarchiv" src="../../../../assets/images/logo.png" id="logo" class="auth-logo img-fluid"></div>
      </div>

      <ng-content></ng-content>

    </div>
  </div>
</div>
